import { useState, useEffect } from "react";
import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
  "https://mtqatiznkmzzshvphzvf.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im10cWF0aXpua216enNodnBoenZmIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc3MzA3NTQxNSwiZXhwIjoyMDg4NjUxNDE1fQ.aIfhXnpwqJWAdtO5WVV-KFD3Rf8JN2dc3I-bokft0vE"
);
const ADMIN_USERNAME = "aweys";
const ADMIN_PASSWORD = "Daahir2!";
const F = "'Nunito', sans-serif";
const RED = "#991B1B";

const subInfo = s => {
  if (s==="active")   return {label:"Active",    color:"#166534", bg:"#F0FFF4", border:"#BBF7D0"};
  if (s==="trialing") return {label:"Trial",     color:"#0369A1", bg:"#EFF6FF", border:"#BAE6FD"};
  if (s==="canceled") return {label:"Cancelled", color:"#991B1B", bg:"#FFF5F5", border:"#FECACA"};
  if (s==="past_due") return {label:"Past Due",  color:"#92400E", bg:"#FFFBEB", border:"#FDE68A"};
  if (s==="unpaid")   return {label:"Unpaid",    color:"#991B1B", bg:"#FFF5F5", border:"#FECACA"};
  return {label:"Unknown", color:"#64748B", bg:"#F8FAFC", border:"#E2E8F0"};
};
const trialDaysLeft = d => Math.ceil((new Date(new Date(d).getTime()+14*864e5)-new Date())/864e5);
const timeAgo = d => {
  const diff=Date.now()-new Date(d).getTime(), m=Math.floor(diff/60000), h=Math.floor(m/60), dy=Math.floor(h/24);
  if(m<2)return"just now"; if(m<60)return m+"m ago"; if(h<24)return h+"h ago";
  if(dy===1)return"Yesterday"; return dy+"d ago";
};
const initials = name => name ? name.split(" ").map(w=>w[0]).join("").toUpperCase().slice(0,2) : "?";
const shortName = name => {
  if (!name) return "?";
  const parts = name.trim().split(" ");
  if (parts.length === 1) return parts[0];
  return parts[0] + " " + parts[parts.length-1][0] + ".";
};
const avatarColor = name => {
  const colors = ["#4A6CF7","#E8394D","#2ECC8A","#9B59B6","#F39C12","#1ABC9C","#E67E22","#3498DB"];
  let hash = 0;
  for(let i=0;i<(name||"").length;i++) hash = name.charCodeAt(i)+((hash<<5)-hash);
  return colors[Math.abs(hash)%colors.length];
};
const todayDate = () => new Date().toLocaleDateString("en-US",{weekday:"long",month:"long",day:"numeric",year:"numeric"});

function Login({onLogin}){
  const [un,setUn]=useState(""), [pw,setPw]=useState(""), [err,setErr]=useState("");
  const go=()=>{ if(un===ADMIN_USERNAME&&pw===ADMIN_PASSWORD)onLogin(); else{setErr("Incorrect credentials");setPw("");} };
  return(
    <div style={{minHeight:"100vh",background:"#F8FAFC",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:F}}>
      <div style={{background:"#fff",borderRadius:20,padding:"40px 36px",width:360,boxShadow:"0 4px 24px rgba(0,0,0,0.08)",border:"1px solid #F0F2F5"}}>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:32}}>
          <img src="https://app.totocare.app/logo512.png" alt="Toto" style={{width:44,height:44,borderRadius:12}}/>
          <div>
            <div style={{fontSize:18,fontWeight:800,color:"#1E293B"}}>toto <span style={{color:"#94A3B8",fontWeight:500,fontSize:14}}>admin</span></div>
            <div style={{fontSize:12,color:"#94A3B8"}}>Owner dashboard</div>
          </div>
        </div>
        {[{lbl:"Username",type:"text",val:un,set:setUn},{lbl:"Password",type:"password",val:pw,set:setPw}].map(f=>(
          <div key={f.lbl}>
            <div style={{fontSize:11,fontWeight:700,color:"#94A3B8",marginBottom:6,textTransform:"uppercase",letterSpacing:"0.08em"}}>{f.lbl}</div>
            <input type={f.type} value={f.val} onChange={e=>f.set(e.target.value)} onKeyDown={e=>e.key==="Enter"&&go()} placeholder={f.lbl}
              style={{width:"100%",padding:"12px 14px",borderRadius:10,border:"1.5px solid #E2E8F0",fontSize:14,fontFamily:F,outline:"none",boxSizing:"border-box",marginBottom:12}}/>
          </div>
        ))}
        {err&&<div style={{color:RED,fontSize:12,marginBottom:12,fontWeight:600}}>⚠ {err}</div>}
        <button onClick={go} style={{width:"100%",padding:"13px",borderRadius:10,border:"none",background:"#1E293B",color:"#fff",fontSize:14,fontFamily:F,fontWeight:700,cursor:"pointer"}}>Sign In →</button>
      </div>
    </div>
  );
}

export default function App(){
  const [authed,setAuthed]=useState(false);
  const [loading,setLoading]=useState(true);
  const [providers,setProviders]=useState([]);
  const [selectedId,setSelectedId]=useState(null);
  const [subStatuses,setSubStatuses]=useState({});
  const [todayAtt,setTodayAtt]=useState([]);
  const [allAtt,setAllAtt]=useState([]);
  const [allChildren,setAllChildren]=useState([]);
  const [todayChildren,setTodayChildren]=useState([]);
  const [billingData,setBillingData]=useState({});
  const [notes,setNotes]=useState({});
  const [notesSaving,setNotesSaving]=useState(false);
  const [billingLoading,setBillingLoading]=useState(false);
  const [msgOpen,setMsgOpen]=useState(false);
  const [msgSubject,setMsgSubject]=useState("");
  const [msgBody,setMsgBody]=useState("");
  const [msgSending,setMsgSending]=useState(false);
  const [msgStatus,setMsgStatus]=useState("");
  const [searchQuery,setSearchQuery]=useState("");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(()=>{ if(!authed){setLoading(false);return;} loadData(); },[authed]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const loadData=async()=>{
    setLoading(true);
    try{
      const today=new Date(); today.setHours(0,0,0,0);
      const [prov,todayRes,childrenRes,allAttRes,todayChildRes]=await Promise.all([
        supabase.from("providers").select("*").order("created_at",{ascending:false}),
        supabase.from("attendance").select("id,provider_id,child_id,created_at").gte("created_at",today.toISOString()),
        supabase.from("children").select("id,provider_id,name"),
        supabase.from("attendance").select("provider_id,created_at").order("created_at",{ascending:false}).limit(200),
        supabase.from("attendance").select("child_id,provider_id,created_at,sign_in_time,sign_out_time").gte("created_at",today.toISOString()),
      ]);
      setProviders(prov.data||[]);
      setTodayAtt(todayRes.data||[]);
      setAllChildren(childrenRes.data||[]);
      setAllAtt(allAttRes.data||[]);
      setTodayChildren(todayChildRes.data||[]);
      if((prov.data||[]).length>0 && !selectedId) setSelectedId(prov.data[0].id);
      const statuses={};
      await Promise.all((prov.data||[]).map(async p=>{
        try{
          const r=await fetch("https://app.totocare.app/api/check-subscription",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({email:p.email})});
          const d=await r.json(); statuses[p.id]=d.status||"unknown";
        }catch(e){statuses[p.id]="unknown";}
      }));
      setSubStatuses(statuses);
    }catch(e){console.error(e);}
    setLoading(false);
  };

  const isTestAccount = p => p.email==="amshei1981@gmail.com" || (p.daycare_name||"").toLowerCase().includes("test");

  // Fetch Stripe billing data for ALL non-test providers on load
  useEffect(() => {
    if (!providers.length) return;
    const toFetch = providers.filter(p => !isTestAccount(p) && p.email && !billingData[p.id]);
    if (!toFetch.length) return;
    setBillingLoading(true);
    Promise.all(
      toFetch.map(p =>
        fetch("/api/provider-billing", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: p.email }),
        })
          .then(r => r.json())
          .then(data => ({ id: p.id, data }))
          .catch(err => { console.error("Billing fetch failed for", p.email, err); return null; })
      )
    ).then(results => {
      const updates = {};
      results.forEach(r => { if (r) updates[r.id] = r.data; });
      setBillingData(prev => ({ ...prev, ...updates }));
      setBillingLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [providers]);

  if(!authed) return <Login onLogin={()=>setAuthed(true)}/>;

  const provTodayCount = pid => todayAtt.filter(a=>a.provider_id===pid).length;
  const provChildCount = pid => allChildren.filter(c=>c.provider_id===pid).length;
  const provLastActive = pid => { const recs=allAtt.filter(a=>a.provider_id===pid); return recs.length>0?recs[0].created_at:null; };


  const needsAttentionCount = providers.filter(p=>{
    const sub=subStatuses[p.id];
    if(["canceled","past_due","unpaid"].includes(sub))return true;
    if(sub==="trialing"&&trialDaysLeft(p.created_at)<=3)return true;
    return false;
  }).length;

  const selected = providers.find(p=>p.id===selectedId);

  // Compute MRR breakdown from billing data
  const mrrStats = (() => {
    let totalMonthly = 0, totalYearly = 0, monthlyCount = 0, yearlyCount = 0;
    Object.values(billingData).forEach(b => {
      if (!b || (b.status !== "active" && b.status !== "trialing")) return;
      if (!b.amount) return;
      const dollars = b.amount / 100;
      if (b.interval === "year") { totalYearly += dollars; yearlyCount++; }
      else { totalMonthly += dollars; monthlyCount++; }
    });
    const mrr = totalMonthly + (totalYearly / 12);
    return { mrr, monthlyCount, yearlyCount, totalActive: monthlyCount + yearlyCount };
  })();
  // eslint-disable-next-line no-unused-vars
  const sub = selected ? (subStatuses[selected.id]||"unknown") : "unknown";
  // const si = subInfo(sub);
  // const days = sub==="trialing" ? trialDaysLeft(selected?.created_at) : null;
  const todayCount = selected ? provTodayCount(selected.id) : 0;
  const childCount = selected ? provChildCount(selected.id) : 0;
  const lastActive = selected ? provLastActive(selected.id) : null;
  const daysSinceSignup = selected ? Math.floor((Date.now()-new Date(selected.created_at).getTime())/864e5) : 0;
  const joinDate = selected ? new Date(selected.created_at).toLocaleDateString("en-US",{month:"long",day:"numeric"}) : "";
  const checkedInToday = selected ? todayChildren.filter(a=>a.provider_id===selected.id).map(a=>a.child_id) : [];
  const provChildrenRaw = selected ? allChildren.filter(c=>c.provider_id===selected.id) : [];
  const provChildren = [...provChildrenRaw].sort((a,b)=>{
    const aIn = checkedInToday.includes(a.id) ? 0 : 1;
    const bIn = checkedInToday.includes(b.id) ? 0 : 1;
    return aIn - bIn;
  });

  return(
    <div style={{minHeight:"100vh",background:"#F8FAFC",fontFamily:F,display:"flex",flexDirection:"column"}}>
      <style>{`
        .provider-item:hover { background: #F1F5F9 !important; }
        .provider-item.active { background: #EFF6FF !important; border-left: 3px solid #4A6CF7 !important; }
        .child-card:hover { box-shadow: 0 4px 12px rgba(0,0,0,0.08) !important; }
        * { box-sizing: border-box; }
      `}</style>

      {/* Top navbar */}
      <div style={{background:"#1E293B",padding:"0 24px",display:"flex",alignItems:"center",justifyContent:"space-between",height:48,flexShrink:0}}>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <img src="https://app.totocare.app/logo512.png" alt="Toto" style={{width:24,height:24,borderRadius:6}}/>
          <span style={{fontSize:14,fontWeight:800,color:"#fff"}}>toto.</span>
          <span style={{fontSize:11,color:"#64748B",background:"#334155",padding:"2px 8px",borderRadius:100,fontWeight:600}}>ADMIN</span>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <span style={{fontSize:12,color:"#94A3B8"}}>{todayDate()}</span>
            {!billingLoading && mrrStats.totalActive > 0 && (
              <div style={{display:"flex",alignItems:"center",gap:14,padding:"7px 14px",background:"rgba(74,222,128,0.18)",border:"1px solid rgba(74,222,128,0.35)",borderRadius:8,marginLeft:14}}>
                <div style={{fontSize:14,fontWeight:800,color:"#4ADE80",letterSpacing:"0.02em"}}>${mrrStats.mrr.toFixed(0)} MRR</div>
                <div style={{width:1,height:16,background:"rgba(74,222,128,0.4)"}}/>
                <div style={{fontSize:12,color:"#86EFAC",fontWeight:600}}>
                  {mrrStats.monthlyCount} monthly · {mrrStats.yearlyCount} yearly
                </div>
              </div>
            )}
          <button onClick={loadData} style={{padding:"5px 12px",borderRadius:7,border:"1px solid #334155",background:"transparent",color:"#94A3B8",fontSize:12,fontFamily:F,fontWeight:600,cursor:"pointer"}}>↻ Refresh</button>
          <button onClick={()=>setAuthed(false)} style={{padding:"5px 12px",borderRadius:7,border:"none",background:"#E8394D",color:"#fff",fontSize:12,fontFamily:F,fontWeight:600,cursor:"pointer"}}>Sign Out</button>
        </div>
      </div>

      <div style={{display:"flex",flex:1,overflow:"hidden",height:"calc(100vh - 48px)"}}>

        {/* Left sidebar */}
        <div style={{width:280,background:"#fff",borderRight:"1px solid #E8ECF0",display:"flex",flexDirection:"column",flexShrink:0}}>
          <div style={{padding:"16px 16px 8px",borderBottom:"1px solid #F1F5F9"}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:10}}>
              <span style={{fontSize:13,fontWeight:800,color:"#1E293B"}}>Providers ({providers.length})</span>
              <button style={{fontSize:12,fontWeight:700,color:"#4A6CF7",background:"none",border:"none",cursor:"pointer"}}>+ Invite</button>
            </div>
            <input type="text" value={searchQuery} onChange={e=>setSearchQuery(e.target.value)} placeholder="Search providers..."
              style={{width:"100%",padding:"7px 10px",borderRadius:8,border:"1.5px solid #E2E8F0",fontSize:12,fontFamily:F,outline:"none",boxSizing:"border-box"}}/>
          </div>
          <div style={{overflowY:"auto",flex:1}}>
            {loading?(
              <div style={{padding:24,textAlign:"center",color:"#94A3B8",fontSize:13}}>Loading...</div>
            ):providers.filter(p=>!searchQuery||(p.daycare_name||"").toLowerCase().includes(searchQuery.toLowerCase())||(p.provider_name||"").toLowerCase().includes(searchQuery.toLowerCase())||(p.email||"").toLowerCase().includes(searchQuery.toLowerCase())).map(p=>{
              const s=subStatuses[p.id]||"unknown";
              const si2=subInfo(s);
              const isActive=p.id===selectedId;
              const dot=["canceled","past_due","unpaid"].includes(s)?"#EF4444":provTodayCount(p.id)>0?"#22C55E":"#94A3B8";
              const av=avatarColor(p.daycare_name);
              return(
                <div key={p.id} className={`provider-item${isActive?" active":""}`}
                  onClick={()=>setSelectedId(p.id)}
                  style={{padding:"12px 16px",borderLeft:`3px solid ${(()=>{const la=provLastActive(p.id);const days=la?Math.floor((Date.now()-new Date(la).getTime())/86400000):null;return(!isTestAccount(p)&&days>=7)?"#EF4444":"transparent";})()}`,cursor:"pointer",transition:"background 0.1s"}}>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <div style={{position:"relative",flexShrink:0}}>
                      <div style={{width:36,height:36,borderRadius:10,background:av,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:800,color:"#fff"}}>{initials(p.daycare_name)}</div>
                      <div style={{position:"absolute",bottom:0,right:0,width:9,height:9,borderRadius:"50%",background:dot,border:"1.5px solid #fff"}}/>
                    </div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:13,fontWeight:800,color:"#1E293B",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{p.daycare_name||"—"}</div>
                      <div style={{fontSize:11,color:"#94A3B8",marginTop:1}}>
                        {p.provider_name} · {provChildCount(p.id)} children
                        {(()=>{const la=provLastActive(p.id);const days=la?Math.floor((Date.now()-new Date(la).getTime())/86400000):null;return(!isTestAccount(p)&&days>=7)?<span style={{color:"#EF4444",fontWeight:700,marginLeft:4}}>· {days}d inactive</span>:null;})()}
                      </div>
                    </div>
                    <div style={{fontSize:10,padding:"2px 7px",borderRadius:100,background:isTestAccount(p)?"#F1F5F9":si2.bg,color:isTestAccount(p)?"#64748B":si2.color,fontWeight:700,border:`1px solid ${isTestAccount(p)?"#E2E8F0":si2.border}`,flexShrink:0}}>
                      {isTestAccount(p)?"Test":si2.label}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Main panel */}
        <div style={{flex:1,overflowY:"auto",padding:"28px 32px"}}>
          {loading?(
            <div style={{textAlign:"center",padding:"80px",color:"#94A3B8",fontSize:15}}>Loading dashboard...</div>
          ):!selected?(
            <div style={{textAlign:"center",padding:"80px",color:"#94A3B8",fontSize:15}}>Select a provider from the sidebar.</div>
          ):(
            <>
              {/* Provider header */}
              <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",marginBottom:20}}>
                <div>
                  <div style={{fontSize:22,fontWeight:900,color:"#1E293B",marginBottom:4}}>{selected.daycare_name||"—"}</div>
                  <div style={{fontSize:13,color:"#94A3B8"}}>{selected.provider_name} · {selected.email} · {selected.city||"Auburn, WA"}</div>
                </div>
                <div style={{display:"flex",alignItems:"center",gap:8,flexShrink:0}}>
                  {needsAttentionCount>0&&(
                    <div style={{fontSize:12,fontWeight:700,color:"#92400E",background:"#FFFBEB",border:"1px solid #FDE68A",borderRadius:8,padding:"6px 12px"}}>
                      ⚠ {needsAttentionCount} need{needsAttentionCount===1?"s":""} attention
                    </div>
                  )}
                  <button onClick={()=>{setMsgSubject("");setMsgBody("");setMsgStatus("");setMsgOpen(true);}} style={{padding:"7px 14px",borderRadius:9,border:"1.5px solid #E2E8F0",background:"#fff",fontSize:13,fontFamily:F,fontWeight:700,color:"#1E293B",cursor:"pointer"}}>Message</button>
                  <button onClick={async()=>{
                    const b=billingData[selected.id];
                    if(!b||!b.subscriptionId){alert("No active subscription found.");return;}
                    if(b.status!=="trialing"){alert("This provider is not currently on a trial.");return;}
                    const days=window.prompt("Extend trial by how many days?","7");
                    if(!days||isNaN(days)||parseInt(days)<=0)return;
                    try{
                      const r=await fetch("/api/extend-trial",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({subscriptionId:b.subscriptionId,days:parseInt(days)})});
                      const d=await r.json();
                      if(d.success){
                        alert(`✅ Trial extended! New end date: ${d.newTrialEndDate}`);
                        setBillingData(p=>({...p,[selected.id]:{...p[selected.id],trialEnd:d.newTrialEnd}}));
                      } else {
                        alert(`Error: ${d.error}`);
                      }
                    }catch(e){alert("Failed to extend trial. Check console.");}
                  }} style={{padding:"7px 14px",borderRadius:9,border:"1.5px solid #E2E8F0",background:"#fff",fontSize:13,fontFamily:F,fontWeight:700,color:"#1E293B",cursor:"pointer"}}>Extend trial</button>
                  <button onClick={()=>window.open("https://app.totocare.app","_blank")} style={{padding:"7px 14px",borderRadius:9,border:"none",background:"#E8394D",color:"#fff",fontSize:13,fontFamily:F,fontWeight:700,cursor:"pointer"}}>View app →</button>
                </div>
              </div>

              {/* Billing banner */}
              <div style={{background:isTestAccount(selected)?"#F8FAFC":"#F0FFF4",borderRadius:12,padding:"14px 20px",border:`1px solid ${isTestAccount(selected)?"#E2E8F0":"#BBF7D0"}`,marginBottom:20,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <div>
                  <div style={{fontSize:14,fontWeight:800,color:isTestAccount(selected)?"#64748B":"#166534"}}>
                    {isTestAccount(selected)?"Test Account":(()=>{
                      const b=billingData[selected.id];
                      if(billingLoading||!b)return "Loading billing...";
                      if(b.status==="no_customer")return "No Stripe customer found";
                      if(b.status==="no_subscription")return "No active subscription";
                      const amt=b.amount?`$${(b.amount/100).toFixed(0)}/${b.interval||"mo"}`:"";
                      return `Toto ${b.interval==="year"?"Yearly":"Monthly"} · ${amt}`;
                    })()}
                  </div>
                  <div style={{fontSize:12,color:"#94A3B8",marginTop:2}}>
                    {isTestAccount(selected)?"Internal test account — no billing":(()=>{
                      const b=billingData[selected.id];
                      if(billingLoading||!b)return " ";
                      if(b.status==="no_customer"||b.status==="no_subscription")return "Customer needs to subscribe";
                      const parts=[];
                      if(b.status==="trialing"&&b.trialEnd){
                        const d=new Date(b.trialEnd*1000);
                        parts.push(`Trial ends ${d.toLocaleDateString("en-US",{month:"short",day:"numeric"})}`);
                      }else if(b.status==="active"){
                        parts.push("Active");
                      }else{
                        parts.push(b.status.charAt(0).toUpperCase()+b.status.slice(1));
                      }
                      if(b.cardBrand&&b.cardLast4)parts.push(`${b.cardBrand.charAt(0).toUpperCase()+b.cardBrand.slice(1)} ${b.cardLast4}`);
                      if(b.cancelAtPeriodEnd){
                        parts.push("Cancels at period end");
                      }else if(b.currentPeriodEnd){
                        const d=new Date(b.currentPeriodEnd*1000);
                        parts.push(`Renews ${d.toLocaleDateString("en-US",{month:"short",day:"numeric"})}`);
                      }
                      return parts.join(" · ");
                    })()}
                  </div>
                </div>
                <button onClick={()=>{
                  const b=billingData[selected.id];
                  if(!b||!b.customerId){alert("No Stripe customer found for this provider.");return;}
                  window.open(`https://dashboard.stripe.com/customers/${b.customerId}`,"_blank");
                }} style={{padding:"7px 14px",borderRadius:9,border:"1.5px solid #E2E8F0",background:"#fff",fontSize:13,fontFamily:F,fontWeight:700,color:"#1E293B",cursor:"pointer"}}>Manage billing</button>
              </div>

              {/* 3 metric cards */}
              <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16,marginBottom:24}}>
                {[
                  {label:"CHECK-INS TODAY", value:todayCount, sub:`of ${childCount} children`},
                  {label:"LAST ACTIVE", value:lastActive?timeAgo(lastActive):"Never", sub:lastActive?`Today at ${new Date(lastActive).toLocaleTimeString("en-US",{hour:"numeric",minute:"2-digit"})}`:"-"},
                  {label:"DAYS SINCE SIGNUP", value:daysSinceSignup, sub:`Joined ${joinDate}`},
                ].map(card=>(
                  <div key={card.label} style={{background:"#fff",borderRadius:12,padding:"20px",border:"1px solid #E8ECF0"}}>
                    <div style={{fontSize:10,fontWeight:700,color:"#94A3B8",textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:8}}>{card.label}</div>
                    <div style={{fontSize:28,fontWeight:900,color:"#1E293B",marginBottom:4}}>{card.value}</div>
                    <div style={{fontSize:12,color:"#94A3B8"}}>{card.sub}</div>
                  </div>
                ))}
              </div>

              {/* Children grid */}
              <div style={{marginBottom:24}}>
                <div style={{fontSize:11,fontWeight:700,color:"#94A3B8",textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:12}}>Children ({childCount})</div>
                {provChildren.length===0?(
                  <div style={{background:"#fff",borderRadius:12,border:"1px solid #E8ECF0",padding:"32px",textAlign:"center",color:"#94A3B8",fontSize:13}}>No children enrolled.</div>
                ):(
                  <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(140px,1fr))",gap:12}}>
                    {provChildren.map(child=>{
                      const checked=checkedInToday.includes(child.id);
                      const av2=avatarColor(child.name);
                      const attRec=todayChildren.find(a=>a.child_id===child.id);
                      const fmt=t=>t?new Date(t).toLocaleTimeString("en-US",{hour:"numeric",minute:"2-digit"}):null;
                      const inTime=attRec?fmt(attRec.sign_in_time||attRec.created_at):null;
                      const outTime=attRec&&attRec.sign_out_time?fmt(attRec.sign_out_time):null;
                      return(
                        <div key={child.id} className="child-card"
                          style={{background:"#fff",borderRadius:12,border:`1.5px solid ${checked?"#BBF7D0":"#E8ECF0"}`,padding:"16px 12px",textAlign:"center",transition:"box-shadow 0.15s"}}>
                          <div style={{width:48,height:48,borderRadius:"50%",background:av2,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,fontWeight:800,color:"#fff",margin:"0 auto 10px"}}>
                            {initials(child.name)}
                          </div>
                          <div style={{fontSize:12,fontWeight:800,color:"#1E293B",marginBottom:4}}>{shortName(child.name)}</div>
                          {checked?(
                            <div style={{fontSize:11,fontWeight:700}}>
                              <span style={{color:"#22C55E"}}>✓ {inTime}</span>
                              {outTime&&<span style={{color:"#EA580C",marginLeft:6,fontWeight:800}}>→ {outTime}</span>}
                            </div>
                          ):(
                            <div style={{fontSize:11,color:"#94A3B8"}}>Not arrived</div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              {/* Admin Notes */}
              <div style={{marginBottom:24}}>
                <div style={{fontSize:11,fontWeight:700,color:"#94A3B8",textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:12}}>Admin Notes</div>
                <div style={{background:"#fff",borderRadius:12,border:"1px solid #E8ECF0",padding:16}}>
                  <textarea
                    value={notes[selected.id]??selected.admin_notes??''}
                    onChange={e=>setNotes(p=>({...p,[selected.id]:e.target.value}))}
                    placeholder="Private notes about this provider — not visible to them..."
                    style={{width:"100%",minHeight:100,border:"none",outline:"none",fontSize:13,fontFamily:F,color:"#1E293B",resize:"vertical",lineHeight:1.6}}
                  />
                  <div style={{display:"flex",justifyContent:"flex-end",marginTop:8}}>
                    <button onClick={async()=>{
                      setNotesSaving(true);
                      await supabase.from("providers").update({admin_notes:notes[selected.id]??''}).eq("id",selected.id);
                      setNotesSaving(false);
                    }} style={{padding:"6px 16px",borderRadius:8,border:"none",background:"#1A365D",color:"#fff",fontSize:12,fontFamily:F,fontWeight:700,cursor:"pointer"}}>
                      {notesSaving?"Saving...":"Save Notes"}
                    </button>
                  </div>
                </div>
              </div>

            </>
          )}
        </div>
      </div>
      {/* Message modal */}
      {msgOpen && selected && (
        <div onClick={()=>!msgSending&&setMsgOpen(false)} style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(15,23,42,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000,padding:20}}>
          <div onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:16,padding:28,maxWidth:560,width:"100%",fontFamily:F,boxShadow:"0 20px 60px rgba(0,0,0,0.3)"}}>
            <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",marginBottom:8}}>
              <div>
                <div style={{fontSize:20,fontWeight:800,color:"#1E293B"}}>Message {selected.daycare_name}</div>
                <div style={{fontSize:13,color:"#64748B",marginTop:4}}>To: {selected.email}</div>
              </div>
              <button onClick={()=>!msgSending&&setMsgOpen(false)} style={{background:"none",border:"none",fontSize:24,color:"#94A3B8",cursor:"pointer",lineHeight:1,padding:0}}>×</button>
            </div>
            <div style={{marginTop:20}}>
              <label style={{fontSize:11,fontWeight:700,color:"#64748B",letterSpacing:"0.05em",textTransform:"uppercase",display:"block",marginBottom:6}}>Subject</label>
              <input value={msgSubject} onChange={e=>setMsgSubject(e.target.value)} disabled={msgSending} placeholder="e.g. Welcome to TotoCare" style={{width:"100%",padding:"10px 14px",border:"1.5px solid #E2E8F0",borderRadius:8,fontSize:14,fontFamily:F,outline:"none",boxSizing:"border-box"}}/>
            </div>
            <div style={{marginTop:14}}>
              <label style={{fontSize:11,fontWeight:700,color:"#64748B",letterSpacing:"0.05em",textTransform:"uppercase",display:"block",marginBottom:6}}>Message</label>
              <textarea value={msgBody} onChange={e=>setMsgBody(e.target.value)} disabled={msgSending} rows={8} placeholder="Write your message..." style={{width:"100%",padding:"10px 14px",border:"1.5px solid #E2E8F0",borderRadius:8,fontSize:14,fontFamily:F,outline:"none",resize:"vertical",boxSizing:"border-box",lineHeight:1.5}}/>
            </div>
            {msgStatus && <div style={{marginTop:12,padding:"10px 14px",borderRadius:8,fontSize:13,background:msgStatus.startsWith("✓")?"#F0FDF4":"#FEF2F2",color:msgStatus.startsWith("✓")?"#166534":"#991B1B",border:`1px solid ${msgStatus.startsWith("✓")?"#BBF7D0":"#FECACA"}`}}>{msgStatus}</div>}
            <div style={{display:"flex",justifyContent:"flex-end",gap:10,marginTop:20}}>
              <button onClick={()=>!msgSending&&setMsgOpen(false)} disabled={msgSending} style={{padding:"9px 16px",borderRadius:9,border:"1.5px solid #E2E8F0",background:"#fff",fontSize:13,fontFamily:F,fontWeight:700,color:"#64748B",cursor:msgSending?"not-allowed":"pointer"}}>Cancel</button>
              <button onClick={async()=>{
                if(!msgSubject.trim()||!msgBody.trim()){setMsgStatus("Please fill in subject and message.");return;}
                setMsgSending(true);setMsgStatus("");
                try{
                  const r=await fetch("/api/send-provider-message",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({to:selected.email,subject:msgSubject,body:msgBody,providerName:selected.provider_name})});
                  const d=await r.json();
                  if(d.success){setMsgStatus("✓ Message sent successfully!");setTimeout(()=>setMsgOpen(false),1500);}
                  else{setMsgStatus(`Error: ${d.error||"Failed to send"}`);}
                }catch(e){setMsgStatus(`Error: ${e.message}`);}
                setMsgSending(false);
              }} disabled={msgSending} style={{padding:"9px 18px",borderRadius:9,border:"none",background:msgSending?"#94A3B8":"#991B1B",fontSize:13,fontFamily:F,fontWeight:700,color:"#fff",cursor:msgSending?"not-allowed":"pointer"}}>{msgSending?"Sending...":"Send Message"}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
